import React, { useEffect, useState } from 'react'
import { Tag } from 'antd'
import { useDispatch, useSelector } from 'react-redux'
import { fetchInterests } from '@/store/actions'
const { CheckableTag } = Tag

export const InterestTags = ({ onChange, selectedInterests }) => {
  const dispatch = useDispatch()
  const { interests } = useSelector((state) => state.common)
  const [updatedInterests, setInterests] = useState(interests)
  const handleChange = (tag, checked) => {
    const selectedTags = []
    if (interests && interests.length > 0) {
      setInterests(
        interests.map((int) => {
          if (int.name == tag.name) int['checked'] = checked
          if (int.checked) selectedTags.push(int.name)
          return int
        })
      )
    }
    onChange(selectedTags)
  }
  useEffect(() => {
    if (!interests) dispatch(fetchInterests())
  }, [])

  useEffect(() => {
    if (interests && interests.length > 0) {
      setInterests(
        interests.map((int) => {
          int['checked'] = selectedInterests.includes(int.name)
          return int
        })
      )
    }
  }, [selectedInterests, interests])

  return (
    <div className="interest-tag-container">
      {updatedInterests &&
        updatedInterests.map((val) => (
          <CheckableTag
            className="interest-tag"
            key={val.name}
            checked={val.checked}
            onChange={(checked) => handleChange(val, checked)}
          >
            {val.name}
          </CheckableTag>
        ))}
    </div>
  )
}
